import { Popover } from "antd";
import React, { useState, useEffect, useContext } from "react";
import InfoContext, { AppContext } from "../../context";
import { openkit } from "../../library/database";
import SDGIcon from "./SDGIcon/SDGIcon";
import "./Sustainability.css";

function Sustainability({
  sustainability,
  lang = "PT",
  iconWidth,
  centerTitle = false,
}) {
  const [odsRatings, setOdsRatings] = useState([]);
  const info = useContext(AppContext);

  const odsCalculateRating = (odsList, odsListCount) => {
    let odsRatings = [];

    // count the number of objectives per main objective
    // add description only if visible was selected in the backoffice
    sustainability?.forEach((odsObj) => {
      if (odsObj.is_true) {
        const element = odsRatings.find((el) => el.name === odsObj.ods_main);
        if (!element) {
          const newElement = {};
          newElement.name = odsObj.ods_main;
          newElement.value = 1;
          newElement.descriptions = [];
          if (odsObj.visible)
            newElement.descriptions.push(
              odsList.find((el) => el.id === odsObj.id).name
            );
          odsRatings.push(newElement);
        } else {
          element.value++;
          if (odsObj.visible)
            element.descriptions.push(
              odsList.find((el) => el.id === odsObj.id).name
            );
        }
      }
    });

    // set the rating (ratio between the number of fulfiled objectives and the total number of objectives per main objective)
    // the rating varies between 1 and 4
    odsRatings = odsRatings.map((ods) => ({
      ...ods,
      rating: Math.round(
        (ods.value / odsListCount.find((el) => el.name === ods.name).count) * 4
      ),
    }));

    // sort odsRatings per ODS number
    odsRatings.sort((a, b) => a.name.localeCompare(b.name));
    setOdsRatings(odsRatings);
  };

  useEffect(() => {
    (async () => {
      // get all the objectives per main objective
      const odsList = await openkit.data.find("c_ods", {});

      // count the number of sub-objectives per main objective
      // to an array [{name: 'ods01', count: 4},{name: 'ods02', count: 4},... ]
      const odsListCount = [];
      odsList.forEach((el, i) => {
        const ods = odsListCount.find((obj) => obj.name === el.ods_main);
        if (!ods) {
          const newOds = {};
          newOds.name = el.ods_main;
          newOds.count = 1;
          odsListCount.push(newOds);
        } else {
          ods.count++;
        }
      });
      // calculate ODS rating
      odsCalculateRating(odsList, odsListCount);
    })();
  }, []);

  const popoverContent = (descriptions) => (
    <div style={{ padding: 15 }}>
      {descriptions.map((d, i) => (
        <p key={i}>{d}</p>
      ))}
    </div>
  );

  return (
    <div className="ahp-sustainability-banner">
      <div
        className="ahp-sustainability-title"
        style={{
          textAlign: centerTitle ? "center" : "left",
        }}
      >
        {info.t("sdg")}
      </div>
      <div
        className="ahp-sustainability-icons"
        style={{ justifyContent: "center" }}
      >
        {odsRatings.map(
          (ods, i) =>
            ods.value > 0 && (
              <Popover
                content={popoverContent(ods.descriptions)}
                title={
                  info.t("sdg") +
                  " " +
                  ods.name.slice(3) +
                  " - " +
                  info.t("fulfiledObjectives") +
                  ":"
                }
                trigger="click"
                key={"pop" + i}
              >
                {/* The next {" "} has to be there, because there has to be some content besides the SDGIcon component for Popover to work */}{" "}
                <SDGIcon
                  imageUrl={`https://aldeiashistoricasdeportugal.com/wp-content/uploads/2022/${
                    lang === "PT" ? "04" : "02"
                  }/${lang}-WEB-Goal-${ods.name.slice(3)}${
                    lang === "PT" ? ".jpeg" : ".png"
                  }`}
                  bars={ods.rating}
                  format="bottom-bars"
                  iconWidth={iconWidth}
                  key={"icon" + i}
                />
              </Popover>
            )
        )}
      </div>
    </div>
  );
}

export default Sustainability;
